const hoursMinutesToLabel = (hour_amount, minute_amount) => {
    var amPM, minute_string;
    if (hour_amount == 0) {
        hour_amount = 12
        amPM = 'AM'
    } else if (hour_amount < 12) {
        amPM = 'AM'
    } else if (hour_amount == 12) {
        amPM = 'PM'
    } else {
        hour_amount = hour_amount - 12
        amPM = 'PM'
    }
    if (minute_amount > 9) {
        minute_string = minute_amount
    } else {
        minute_string = '0' + minute_amount.toString()
    }
    return hour_amount + ":" + minute_string + amPM
}

const fullMonthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
]

const shortMonthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
]

const DateHelpers = {
    differenceBetweenTimeStampsInS: (time_stamp_1, time_stamp_2) => {
        var date1 = new Date(time_stamp_1);
        var date2 = new Date(time_stamp_2);
        return (date1.getTime() - date2.getTime()) / 1000;
    },

    timeStampToLabelFull: (chosen_date, include_time = false) => {
        var chosen_date = new Date(chosen_date.toString());
        var today = new Date();
        if (include_time == true) {
            return fullMonthNames[chosen_date.getMonth()] + ' ' + chosen_date.getDate() + ', ' + chosen_date.getFullYear() + ' ' + hoursMinutesToLabel(chosen_date.getHours(), chosen_date.getMinutes());
        } else {
            return fullMonthNames[chosen_date.getMonth()] + ' ' + chosen_date.getDate() + ', ' + chosen_date.getFullYear();
        }
    },

    timeStampToLabel: (chosen_date, include_time = false) => {
        var chosen_date = new Date(chosen_date.toString());
        var today = new Date();
        // if (chosen_date.getDate() == today.getDate() && chosen_date.getMonth() == today.getMonth() && chosen_date.getFullYear() == today.getFullYear()) {
        // return hoursMinutesToLabel(chosen_date.getHours(), chosen_date.getMinutes());
        // }
        if (include_time == true) {
            return shortMonthNames[chosen_date.getMonth()] + ' ' + chosen_date.getDate() + ', ' + chosen_date.getFullYear() + ' - ' + hoursMinutesToLabel(chosen_date.getHours(), chosen_date.getMinutes());
        } else {
            return shortMonthNames[chosen_date.getMonth()] + ' ' + chosen_date.getDate() + ', ' + chosen_date.getFullYear();
        }

    }
}

export default DateHelpers;
